import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Checkbox, Divider, Popover } from "antd";
import {
  setAttrFilter,
  setFilters,
  clearAttrFilter,
  clearFilters,
} from "../../redux/actions/shopActions";
import { hideSideBar } from "../../redux/actions/miscActions";

export class Filters extends Component {
  setProductFilters = (value) => {
    if (value.length === 0) {
      this.props.clearFilters();
      this.props.hideSideBar();
    } else {
      this.props.setFilters(value[0]);
      this.props.hideSideBar();
    }
  };

  setSubFilters = (value) => {
    if (value.length === 0) {
      this.props.clearAttrFilter();
    } else {
      this.props.setAttrFilter(value[0]);
    }
  };

  handleClearFilters = () => {
    this.props.clearAttrFilter();
    this.props.clearFilters();
    this.props.hideSideBar();
  };

  handleLinkClick = (link) => {
    this.props.history.push(`/${link}`);
    this.props.hideSideBar();
  };

  componentDidUpdate = (prevProps) => {
    if (
      prevProps.shop.filters.includes("Groenten") &&
      !this.props.shop.filters.includes("Groenten")
    ) {
      this.props.clearAttrFilter();
    }
  };
  render() {
    const { filters, subFilters } = this.props.shop;
    const leverkosten = (
      <ul className="leverkosten">
        <li>Paramaribo</li>
        <li>Gratis voor bestellingen boven SRD 300</li>
        <li>SRD 17,50 voor bestellingen onder SRD 300</li>

        <li>Wanica & Commewijne</li>
        <li>SRD 50 voor bestellingen boven SRD 500</li>
        <li>SRD 100 voor bestellingen onder SRD 500</li>

        <li>Para & Brokopondo</li>
        <li>SRD 100 voor bestellingen boven SRD 500</li>
        <li>SRD 150 voor bestellingen onder SRD 500</li>
      </ul>
    );
    return (
      <div className="shop-filters">
        <div className="header">
          <h3>Filters</h3>
          {filters.length > 0 ? (
            <h3 onClick={this.handleClearFilters}>Clear filters</h3>
          ) : null}
        </div>
        <Checkbox.Group
          onChange={this.setProductFilters}
          value={filters}
          className="main-filter"
        >
          <Checkbox value="Groenten">Groenten</Checkbox>
          {filters && filters.length > 0 && filters.includes("Groenten") ? (
            <Checkbox.Group
              onChange={this.setSubFilters}
              value={
                filters.length > 0 && filters.includes("Groenten")
                  ? subFilters
                  : []
              }
              className="sub-filter"
            >
              <Checkbox value="Bosjes">Bosjes</Checkbox>
              <Checkbox value="Cubes verpakt">Cubes verpakt</Checkbox>
              <Checkbox value="Fijngesneden">Fijngesneden</Checkbox>
              <Checkbox value="Schoongemaakt">Schoongemaakt</Checkbox>
              <Checkbox value="Gesneden">Gesneden</Checkbox>
              <Checkbox value="Geschild">Geschild</Checkbox>
              <Checkbox value="Heel">Heel</Checkbox>
              <Checkbox value="Ongeschild">Ongeschild</Checkbox>
              <Checkbox value="Uitgehold">Uitgehold</Checkbox>
              <Checkbox value="Bevroren">Bevroren</Checkbox>
            </Checkbox.Group>
          ) : null}
          <Checkbox value="Fruit">Fruit</Checkbox>
          <Checkbox value="Sap">Sap</Checkbox>
          <Checkbox value="aardvrucht">Aardvruchten</Checkbox>
          <Checkbox value="specerijen">Specerijen</Checkbox>
        </Checkbox.Group>
        <Divider />
        <p className="link" onClick={() => this.handleLinkClick("pakketten")}>
          Pakketten <i className="fas fa-angle-right"></i>
        </p>
        {/* <p className="link" onClick={()=>this.handleLinkClick('')}>
          Zelf samenstellen <i className="fas fa-angle-right"></i>
        </p> */}
        {/* <p className="link" onClick={()=>this.handleLinkClick('zuivel-producten')}>
          Zuivelproducten <i className="fas fa-angle-right"></i>
        </p> */}
        <Divider />
        <div className="vendor-contact-info"></div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  shop: state.shop,
});

export default connect(mapStateToProps, {
  setAttrFilter,
  setFilters,
  clearAttrFilter,
  clearFilters,
  hideSideBar,
})(withRouter(Filters));
